import styled from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  className: string;
}

export const ProductList = styled.div<IProps>`
  overflow: hidden;

  &.per-view-3 {
    // 3열에서는 전체 폭을 차지하는 코너도 3칸을 채운다
    .corner-sponsored-banner,
    .corner-recommend,
    .corner-recommend-styling {
      grid-column: span 3;
    }

    .area-img {
      .emblem-area {
        height: 50px;

        svg {
          width: 32px;
          top: 8px;
          right: 7px;
        }
      }
    }

    .rank {
      width: 20px;
      height: 20px;
      line-height: 20px;
      font-size: 11px;
      font-weight: 500;
    }

    .tag-sale {
      padding: 4px;
      left: 8px;
      font-size: 11px;
    }

    .like-pick {
      top: 2px;
      right: 0;
    }

    .area-click {
      padding: 10px 8px 0 8px;

      .prdc-price {
        margin-top: 4px;
      }
    }

    .area-tag {
      display: flex;
      gap: 4px;
      flex-wrap: wrap;

      .tag {
        margin-left: 0;
        padding: 3px;
      }
    }

    .area-ad-tag {
      .tag.tag-ad {
        width: 24px;
        height: 16px;
        padding: 2px 3px;
        font-size: 10px;
      }
    }

    .stats {
      ${mixin.flex({
        wrap: 'wrap',
        direction: 'column',
        align: 'flex-start',
      })};
      row-gap: 4px;

      .review,
      .like {
        margin-left: 0;
        svg {
          margin: 0 2px;
        }
      }
      .like {
        svg + span {
          margin-left: 2px;
        }
      }
    }

    .color-chips {
      padding-left: 8px;
    }

    .corner-recommend-styling,
    .corner-recommend {
      grid-column: span 3;
    }
  }

  // 모바일 lp 상품 virtual 모드
  [data-virtuoso-scroller] {
    [data-testid='virtuoso-item-list'] {
      display: flex;
      flex-direction: column;
      row-gap: 36px;
    }

    [data-item-index] {
      display: flex;
      column-gap: 1px;

      .corner-recommend-styling,
      .corner-recommend {
        width: 100%;
      }

      > .item {
        flex: 0 0
          calc(
            (100% - (var(--lp-mobile-virt-cols, 2) - 1) * 1px) /
              var(--lp-mobile-virt-cols, 2)
          );
        max-width: calc(
          (100% - (var(--lp-mobile-virt-cols, 2) - 1) * 1px) /
            var(--lp-mobile-virt-cols, 2)
        );
        min-width: 0;
      }
    }
  }

  // 심플형 아이템
  .item.type-simple {
    .area-info {
      .area-click {
        padding: 12px 12px 0 12px;
      }

      .like-pick {
        top: 4px;
        right: 4px;
      }
    }
  }

  // 광고
  .corner-recommend {
    grid-column: span 2;

    .product-item.item.type-simple {
      .area-info {
        .area-click {
          padding: 6px 4px 0 4px;
        }

        .like-pick {
          top: -2px;
          right: -4px;
        }
      }
    }

    &:has(.bg-type) {
      margin-bottom: -35px;
    }
  }

  // 스타일링
  .corner-recommend-styling {
    grid-column: span 2;
    margin: -4px 0;

    .list {
      margin-top: 12px;
    }

    .main-title {
      padding: 0 20px;
      line-height: 130%;
      font-size: 18px;
      font-weight: 600;

      .tooltip-popup {
        top: 2px;
        z-index: 2;

        svg path {
          fill: #bbb;
        }

        .tooltip-item {
          left: -28px;
          max-width: 240px;
        }
      }

      .sub-title {
        padding-right: 20px;
        line-height: 130%;
        font-size: 12px;
        color: #777;
        font-weight: 400;
      }
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    &.per-view-3 {
      .area-img {
        .emblem-area {
          height: ${mixin.pxToVw('50')};

          svg {
            width: ${mixin.pxToVw('32')};
            top: ${mixin.pxToVw('8')};
            right: ${mixin.pxToVw('7')};
          }
        }
      }

      .rank {
        width: ${mixin.pxToVw('20')};
        height: ${mixin.pxToVw('20')};
        line-height: ${mixin.pxToVw('20')};
        font-size: ${mixin.pxToVw('11')};
      }

      .area-click {
        padding: ${mixin.pxToVw('10 8 0 8')};

        .prdc-price {
          margin-top: ${mixin.pxToVw('4')};
        }
      }

      .tag-sale {
        padding: ${mixin.pxToVw('4')};
        left: ${mixin.pxToVw('8')};
      }

      .area-tag {
        gap: ${mixin.pxToVw('4')};

        .tag {
          padding: ${mixin.pxToVw('3')};
        }
      }

      .area-ad-tag {
        .tag.tag-ad {
          width: ${mixin.pxToVw('24')};
          height: ${mixin.pxToVw('16')};
          padding: ${mixin.pxToVw('2')} ${mixin.pxToVw('3')};
          font-size: ${mixin.pxToVw('10')};
        }
      }

      .like-pick {
        top: ${mixin.pxToVw('2')};
      }

      .stats {
        row-gap: ${mixin.pxToVw('4')};
      }

      .color-chips {
        padding-left: ${mixin.pxToVw('8')};
      }
    }

    [data-virtuoso-scroller] {
      [data-testid='virtuoso-item-list'] {
        row-gap: ${mixin.pxToVw('36')};
      }

      [data-item-index] {
        column-gap: ${mixin.pxToVw('1')};
      }
    }

    .item.type-simple {
      .area-info {
        .area-click {
          padding: ${mixin.pxToVw('12 12 0 12')};
        }

        .like-pick {
          top: ${mixin.pxToVw('4')};
          right: ${mixin.pxToVw('4')};
        }
      }
    }

    .corner-recommend {
      .product-item .area-info {
        .area-click {
          padding: ${mixin.pxToVw('6 4 0 4')};
        }

        .like-pick {
          top: ${mixin.pxToVw('-2')};
          right: ${mixin.pxToVw('-4')};
        }
      }

      &:has(.bg-type) {
        margin-bottom: ${mixin.pxToVw('-35')};
      }
    }

    .corner-recommend-styling {
      margin: ${mixin.pxToVw('-4 0')};

      .list {
        margin-top: ${mixin.pxToVw('12')};
      }

      .main-title {
        padding: ${mixin.pxToVw('0 20')};
        font-size: ${mixin.pxToVw('18')};

        .tooltip-popup {
          top: ${mixin.pxToVw('2')};

          .tooltip-item {
            left: ${mixin.pxToVw('-28')};
            max-width: ${mixin.pxToVw('240')};
          }
        }

        .sub-title {
          padding-right: ${mixin.pxToVw('20')};
          font-size: ${mixin.pxToVw('12')};
        }
      }
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    .item.type-simple {
      .area-info {
        .area-click {
          padding: 14px 0 0 0;
        }

        .like-pick {
          top: 14px;
          right: 0px;
        }
      }
    }
  }
`;
